export const SCORPION_BUSINESS_METRICS_URL =
"https://cw-dashboards.aka.amazon.com/cloudwatch/?accountId=674300632218&region=us-east-1#dashboards/dashboard/BUSINESS_METRICS";

export const HOVER_METRICS_BANNER_CONTENT = "In this dashboard, we show how many on-call handover reports are generated " +
    "successfully, number of users used Hover Tool and number of teams used hover tool in the specified time frame.";